<template>
  <f7-page>
    <f7-navbar title="Email 更新身份驗證" back-link="back">
      <f7-nav-right>
        <f7-link @click="confirm">確認</f7-link>
      </f7-nav-right>
    </f7-navbar>

    <f7-block>
      您所要操作的為高安全性資料，請重新輸入您的帳號密碼。
    </f7-block>

    <f7-list media-list>
      <f7-list-item ref="email">
        <f7-label floating>帳號 (Email):</f7-label>
        <f7-input type="text" :value="email" @input="email = $event.target.value" @focus="onFocus('email')" clear-button />
      </f7-list-item>
      <f7-list-item ref="password">
        <f7-label floating>密碼:</f7-label>
        <f7-input type="password" :value="password" @input="password = $event.target.value" @focus="onFocus('password')" clear-button />
      </f7-list-item>
      <f7-list-item ref="newEmail">
        <f7-label floating>新帳號 (Email):</f7-label>
        <f7-input type="text" :value="newEmail" @input="newEmail = $event.target.value" @focus="onFocus('newEmail')" clear-button />
      </f7-list-item>
    </f7-list>
  </f7-page>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  data () {
    return {
      email: null,
      password: null,
      newEmail: null
    }
  },
  methods: {
    ...mapActions('userModule', ['updateEmail']),
    onFocus (field) {
      this.$refs[field].$el.scrollIntoView({ behavior: 'smooth', block: 'nearest' })
    },
    async confirm () {
      this.$f7.dialog.progress('正在更新，請稍待...')
      await this.updateEmail({ email: this.email, password: this.password, newEmail: this.newEmail })
      this.$utils.nextFrame(() => this.$f7.dialog.close())
      this.$f7.notification.create({
        title: '更新完成',
        text: '請至所填的 Eamil 信箱點選認證信件內的連結',
        closeOnClick: true,
        closeButton: true
      }).open()
      this.$f7router.back()
    }
  }
}
</script>
